import { Lead, Loan, Retention } from '../types'

const defaultHistory = [
  {
    id: 'h2',
    date: '2023-10-22T14:30:00Z',
    type: 'email' as const,
    description: 'Sent initial rate quote',
  },
  {
    id: 'h3',
    date: '2023-10-20T09:15:00Z',
    type: 'note' as const,
    description: 'Lead imported from Zillow',
  },
]

const today = new Date().toISOString().split('T')[0]

export const mockLeads: Lead[] = [
  {
    id: 'ld1',
    type: 'lead',
    name: 'Sarah Johnson',
    phone: '(555) 123-4567',
    email: 'sarah.j@example.com',
    address: '123 Maple St, Austin, TX',
    source: 'Zillow',
    daysSinceContact: 2,
    scheduledFollowUp: today,
    history: [
      {
        id: 'h1',
        date: '2023-10-24T10:00:00Z',
        type: 'note',
        description: 'Interested in 3BR near downtown, pre-qual needed',
      },
      ...defaultHistory,
    ],
  },
  {
    id: 'ld2',
    type: 'lead',
    name: 'Michael Chen',
    phone: '(555) 987-6543',
    email: 'mchen88@example.com',
    address: '456 Oak Ave, Seattle, WA',
    source: 'Website',
    daysSinceContact: 5,
    history: [
      {
        id: 'h1',
        date: '2023-10-21T09:00:00Z',
        type: 'note',
        description: 'Looking to refinance, wants rate comparison',
      },
      ...defaultHistory,
    ],
  },
  {
    id: 'ld3',
    type: 'lead',
    name: 'Lisa Rodriguez',
    phone: '(555) 456-7890',
    email: 'lisa.rod@example.com',
    address: '789 Pine Rd, Miami, FL',
    source: 'Referral',
    daysSinceContact: 1,
    scheduledFollowUp: today,
    history: [
      {
        id: 'h1',
        date: '2023-10-25T11:30:00Z',
        type: 'note',
        description:
          'Referred by David M. — first-time buyer, eager to move fast',
      },
      ...defaultHistory,
    ],
  },
  {
    id: 'ld4',
    type: 'lead',
    name: 'James Smith',
    phone: '(555) 222-3333',
    email: 'jsmith@example.com',
    address: '321 Elm St, Denver, CO',
    source: 'LendingTree',
    daysSinceContact: 14,
    history: [
      {
        id: 'h1',
        date: '2023-10-12T16:00:00Z',
        type: 'note',
        description: 'No answer on 3 attempts, try again next week',
      },
      ...defaultHistory,
    ],
  },
  {
    id: 'ld5',
    type: 'lead',
    name: 'Emily Davis',
    phone: '(555) 444-5555',
    email: 'edavis@example.com',
    address: '654 Birch Ln, Chicago, IL',
    source: 'Website',
    daysSinceContact: 0,
    history: [
      {
        id: 'h1',
        date: '2023-10-26T08:45:00Z',
        type: 'note',
        description: 'Just submitted app — wants callback ASAP',
      },
      ...defaultHistory,
    ],
  },
  {
    id: 'ld6',
    type: 'lead',
    name: 'Robert Wilson',
    phone: '(555) 666-7777',
    email: 'rwilson@example.com',
    address: '987 Cedar Ct, Phoenix, AZ',
    source: 'Zillow',
    daysSinceContact: 3,
    history: [
      {
        id: 'h1',
        date: '2023-10-23T14:00:00Z',
        type: 'note',
        description: 'Discussed FHA options, sending docs tomorrow',
      },
      ...defaultHistory,
    ],
  },
  {
    id: 'ld7',
    type: 'lead',
    name: 'Amanda Taylor',
    phone: '(555) 888-9999',
    email: 'ataylor@example.com',
    address: '147 Spruce Dr, Dallas, TX',
    source: 'Referral',
    daysSinceContact: 7,
    history: [
      {
        id: 'h1',
        date: '2023-10-19T10:15:00Z',
        type: 'note',
        description: 'Waiting on W-2s from employer before proceeding',
      },
      ...defaultHistory,
    ],
  },
  {
    id: 'ld8',
    type: 'lead',
    name: 'David Anderson',
    phone: '(555) 111-2222',
    email: 'danderson@example.com',
    address: '258 Ash Blvd, Atlanta, GA',
    source: 'Website',
    daysSinceContact: 10,
    history: [
      {
        id: 'h1',
        date: '2023-10-16T13:30:00Z',
        type: 'note',
        description: 'Said to call back after Thanksgiving',
      },
      ...defaultHistory,
    ],
  },
]

const loanHistory = [
  {
    id: 'h1',
    date: '2023-10-24T10:00:00Z',
    type: 'call' as const,
    description: 'Left voicemail about missing docs',
  },
  {
    id: 'h2',
    date: '2023-10-22T14:30:00Z',
    type: 'email' as const,
    description: 'Sent document checklist',
  },
  {
    id: 'h3',
    date: '2023-10-20T09:15:00Z',
    type: 'note' as const,
    description: 'Loan application submitted',
  },
]

const retentionHistory = [
  {
    id: 'h1',
    date: '2023-10-24T10:00:00Z',
    type: 'call' as const,
    description: 'Left voicemail',
  },
  {
    id: 'h2',
    date: '2023-10-22T14:30:00Z',
    type: 'email' as const,
    description: 'Sent retention offer',
  },
  {
    id: 'h3',
    date: '2023-10-20T09:15:00Z',
    type: 'note' as const,
    description: 'Flagged for retention outreach',
  },
]

export const mockLoans: Loan[] = [
  {
    id: 'ln1',
    type: 'loan',
    name: 'James Wilson',
    phone: '(555) 321-6547',
    email: 'jwilson.loan@example.com',
    address: '741 Willow Way, Boston, MA',
    amount: 425000,
    loanType: 'Conventional',
    docsReceived: 3,
    docsTotal: 5,
    daysInPipeline: 4,
    history: loanHistory,
  },
  {
    id: 'ln2',
    type: 'loan',
    name: 'Amanda Foster',
    phone: '(555) 654-9871',
    email: 'afoster@example.com',
    address: '852 Cherry St, Portland, OR',
    amount: 280000,
    loanType: 'FHA',
    docsReceived: 1,
    docsTotal: 4,
    daysInPipeline: 7,
    scheduledFollowUp: today,
    history: loanHistory,
  },
  {
    id: 'ln3',
    type: 'loan',
    name: 'Robert Kim',
    phone: '(555) 789-1234',
    email: 'rkim.jumbo@example.com',
    address: '963 Magnolia Ave, San Diego, CA',
    amount: 650000,
    loanType: 'Jumbo',
    docsReceived: 4,
    docsTotal: 6,
    daysInPipeline: 2,
    history: loanHistory,
  },
  {
    id: 'ln4',
    type: 'loan',
    name: 'Jessica Brown',
    phone: '(555) 159-7532',
    email: 'jbrown@example.com',
    address: '159 Poplar Pl, Nashville, TN',
    amount: 315000,
    loanType: 'VA',
    docsReceived: 0,
    docsTotal: 3,
    daysInPipeline: 1,
    history: loanHistory,
  },
  {
    id: 'ln5',
    type: 'loan',
    name: 'Thomas Garcia',
    phone: '(555) 357-9514',
    email: 'tgarcia@example.com',
    address: '753 Sycamore Dr, Charlotte, NC',
    amount: 500000,
    loanType: 'Conventional',
    docsReceived: 5,
    docsTotal: 5,
    daysInPipeline: 12,
    history: loanHistory,
  },
]

export const mockRetention: Retention[] = [
  {
    id: 'rt1',
    type: 'retention',
    name: 'David Martinez',
    phone: '(555) 456-1237',
    email: 'dmartinez@example.com',
    address: '123 Palm Tree Ln, Orlando, FL',
    originalLoanDate: '2022-04-15',
    amount: 350000,
    triggerReason: 'Rate drop opportunity',
    scheduledFollowUp: today,
    history: retentionHistory,
  },
  {
    id: 'rt2',
    type: 'retention',
    name: 'Jennifer Lee',
    phone: '(555) 789-4561',
    email: 'jlee.retention@example.com',
    address: '456 Redwood Rd, San Jose, CA',
    originalLoanDate: '2021-10-01',
    amount: 275000,
    triggerReason: 'ARM adjustment approaching',
    history: retentionHistory,
  },
  {
    id: 'rt3',
    type: 'retention',
    name: 'William Clark',
    phone: '(555) 123-7894',
    email: 'wclark@example.com',
    address: '789 Cypress Ct, Houston, TX',
    originalLoanDate: '2020-08-20',
    amount: 410000,
    triggerReason: 'High equity / Cash-out potential',
    history: retentionHistory,
  },
  {
    id: 'rt4',
    type: 'retention',
    name: 'Elizabeth White',
    phone: '(555) 987-3216',
    email: 'ewhite@example.com',
    address: '321 Hickory St, Philadelphia, PA',
    originalLoanDate: '2019-05-10',
    amount: 225000,
    triggerReason: 'Birthday / Annual Review',
    history: retentionHistory,
  },
]
